function Footer() {
  return (
<footer>
  <div className="container">
    <div className="row g-4">
      <div className="col-md-4">
        <h6>🪷 Velama Pelli Pandiri</h6>
        <p style={{fontSize: '.85rem', opacity: '.7', lineHeight: '1.7'}}>
          A trusted matrimonial platform exclusively serving the Velama community. Connecting families with tradition, trust, and care since 2019.
        </p>
      </div>
      <div className="col-md-2">
        <h6>Quick Links</h6>
        <ul className="list-unstyled" style={{lineHeight: 2}}>
          <li><a href="#">Profiles</a></li>
          <li><a href="#">Add Profile</a></li>
          <li><a href="#">Pending</a></li>
          <li><a href="#">Inactive</a></li>
        </ul>
      </div>
      <div className="col-md-3">
        <h6>Community</h6>
        <ul className="list-unstyled" style={{lineHeight: 2}}>
          <li><a href="#">About Us</a></li>
          <li><a href="#">Success Stories</a></li>
          <li><a href="#">Privacy Policy</a></li>
          <li><a href="#">Terms &amp; Conditions</a></li>
        </ul>
      </div>
      <div className="col-md-3">
        <h6>Contact</h6>
        <p style={{fontSize: '.85rem', opacity: '.7', lineHeight: '1.9'}}>
          <i className="fas fa-phone me-2" style={{color: 'var(--gold)'}} />+91 99999 00000<br />
          <i className="fas fa-envelope me-2" style={{color: 'var(--gold)'}} />info@velamapelli.com<br />
          <i className="fas fa-map-marker-alt me-2" style={{color: 'var(--gold)'}} />Andhra Pradesh, India
        </p>
        <div className="d-flex gap-3 mt-2">
          <a href="#" style={{color: 'var(--gold-light)', fontSize: '1.2rem'}}><i className="fab fa-facebook" /></a>
          <a href="#" style={{color: 'var(--gold-light)', fontSize: '1.2rem'}}><i className="fab fa-whatsapp" /></a>
          <a href="#" style={{color: 'var(--gold-light)', fontSize: '1.2rem'}}><i className="fab fa-instagram" /></a>
          <a href="#" style={{color: 'var(--gold-light)', fontSize: '1.2rem'}}><i className="fab fa-youtube" /></a>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      © 2026 Velama Pelli Pandiri. All rights reserved. | Made with ❤️ for the Velama Community
    </div>
  </div>
</footer>

  );
}
export default Footer;
